"use client";

import React, { useState } from "react";
import { NoItems } from "@/app/(components)/Basic/NoItems";
import { NFT_LIST_OPTIONS, NftSortValues } from "../../Collections/types";
import useCollectionInfiniteNfts from "./hooks/useCollectionInfiniteNfts";
import { NftList } from "../../Nft/NftList";

export interface Props {
  collectionId: string;
}

const CollectionNftList = ({ collectionId }: Props) => {
  const [sort, setSort] = useState<NftSortValues>(NftSortValues.NEWEST);

  const sortOption = NFT_LIST_OPTIONS.find((o) => o.value === sort)!;

  const { nfts, hasNextPage, fetchNextPage } = useCollectionInfiniteNfts({
    collectionId,
    order: sortOption.order,
    orderDirection: sortOption.orderDirection,
  });

  if (!nfts?.length) {
    return <NoItems message="No items to display!" />;
  }

  return (
    <NftList
      nfts={nfts}
      sortOption={sort}
      setSortOption={setSort}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage!}
      hasDropdownFilter
    />
  );
};

export default CollectionNftList;
